import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { IUser } from '@relab/alstom-ptw-shared';

import { HeaderComponent } from '../components/HeaderComponent';
import { appState, appStateServerRequests } from '../redux/selectors';
import { NavBar } from '../components/NavBar';
import { UserCreateComponent } from '../components/user/UserCreateComponent';
import { signUpAction, usersAction } from '../redux/actions';
import { ActionType, RootState, ServerRequestStatus } from '../redux/types';
import { UsersListComponent } from '../components/user/UsersListComponent';

interface UsersSceneProps extends Component {
  users: IUser[];
  usersAction: typeof usersAction;
  signUpAction: typeof signUpAction;
  createUserServerRequest?: ServerRequestStatus;
}

class PUsersScene extends Component<UsersSceneProps> {
  componentDidMount(): void {
    this.props.usersAction();
  }

  render() {
    const { createUserServerRequest, users, signUpAction } = this.props;

    return (
      <>
        <HeaderComponent />
        <NavBar />
        <Container fluid>
          <UserCreateComponent onCreateUser={signUpAction} createUserServerRequest={createUserServerRequest} />
          <UsersListComponent users={users} />
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  users: appState(state).users,
  createUserServerRequest: appStateServerRequests(state, ActionType.SIGN_UP),
});

export const UsersScene = connect(mapStateToProps, { usersAction, signUpAction })(PUsersScene);
